import { skipToken } from '@apollo/client/react'
import { useCheckTokenForArgs } from 'src/utils/token'
import {
  GetMyUnreadNotiCountDocument,
  GetNotificationDocument,
  ListMyNotificationsDocument,
  ListNotificationsDocument,
  MarkNotificationReadDocument,
} from './generated/graphql'
import {
  createFetchQueryHelper,
  createMutationHelper,
  createQueryHook,
  createRefetchQueryHelper,
  modifyQueryHook,
} from './utils'

export const useGetNotification = modifyQueryHook(
  createQueryHook(GetNotificationDocument),
  {
    transform: (id: string) => ({ id }),
    reduce: r => r?.notification,
  },
)

export const useListNotifications = modifyQueryHook(
  createQueryHook(ListNotificationsDocument),
  {
    reduce: r => r?.notifications,
  },
)
export const fetchListNotifications = createFetchQueryHelper(
  ListNotificationsDocument,
)

export const useListMyNotifications = modifyQueryHook(
  createQueryHook(ListMyNotificationsDocument),
  {
    reduce: r => r?.me?.notifications,
  },
)
export const refetchListMyNotifications = createRefetchQueryHelper(
  ListMyNotificationsDocument,
)
export const fetchListMyNotifications = createFetchQueryHelper(
  ListMyNotificationsDocument,
)

const useGetMyUnreadNotiCount = modifyQueryHook(
  createQueryHook(GetMyUnreadNotiCountDocument),
  {
    reduce: r => r?.me?.unreadNotificationCounts,
  },
)
export const useMyUnreadNotiCounts = () => {
  const input = useCheckTokenForArgs({})
  const res = useGetMyUnreadNotiCount(input ?? skipToken)

  // Notification refetches are now handled by usePersonalEventsSync in subscriptions.ts

  return res
}

export const [useMarkNotificationRead, executeMarkNotificationRead] =
  createMutationHelper(MarkNotificationReadDocument)
